import {IncreaseProductivityImg}  from '../../../../../images/index'
import KPSlideCard from '../../../Cards/KPSlideCard';
import {One, Two, Three, Four} from '../../../../../images/index'

export default function IncreaseProductivitySlideV2() {

  const dentistCards = [
    {
      name:"John Smith",
      title: "MBBS",
      img: One,
      location: "United States"
    },
    {
      name:"John Smith",
      title: "MBBS",
      img: Two,
      location: "United States"
    },
    {
      name:"John Smith",
      title: "MBBS",
      img: Three,
      location: "United States"
    },
    {
      name:"John Smith",
      title: "MBBS",
      img: Four,
      location: "United States"
    },
  ]
  
  return (
    <div className="relative h-screen bg-bgDark lg:bg-none flex flex-col lg:flex-row ">
      <div className="px-6 lg:px-0 h-1/2 pt-32 lg:pt-0 lg:h-full w-full flex flex-col justify-center text-center  lg:w-1/2 lg:text-left ">
        <div className="z-10 px-4 max-w-2xl mx-auto sm:px-8 pb-12 md:pb-20 lg:pt-0">
          <h1 className="text-center lg:text-left text-white text-2xl sm:text-3xl lg:text-4xl font-semibold">Grow bigger with the XiViX Knowledge Portal</h1>
          <div className='my-2 mx-auto lg:mx-0 lg:my-4 w-32 border border-gray-300'/>
          <p className="mt-3 text-lg text-gray-500 sm:text-xl md:mt-5 md:max-w-3xl">
            <p className="text-center lg:text-left text-white my-1">A network of competence and knowledge, XiViX's Knowledge Portal enables learning and collaboration with key opinion leader from across the globe.</p>
          </p>
        </div>
      </div>
      <div className="pb-16 lg:pb-0 lg:pr-24 lg:flex-grow h-1/2 lg:h-auto flex my-auto justify-center align-middle gap-4 xl:gap-16">
        <div className="flex flex-row lg:flex-col my-auto lg:my-auto gap-32 xl:gap-44">
          <KPSlideCard dentistCard= {dentistCards[0]}/>
          <div className='hidden md:block'>
            <KPSlideCard dentistCard= {dentistCards[2]}/>
          </div>
        </div>
        <div className="hidden lg:flex flex-col gap-32 xl:gap-44 mt-6">
          <KPSlideCard dentistCard= {dentistCards[1]} right/>
          <KPSlideCard dentistCard= {dentistCards[3]} right/>
        </div>
      </div>
    </div>
  )
};

/* 
import React from 'react'
import Button from '../../../Button'
import useWindowSize from '../../../../../hooks/useWindowSize'
import KPSlideCard from '../../../Cards/KPSlideCard';
import {One, Two, Three, Four} from '../../../../../images/index'

function KnowledgePortal2() {

  const size=useWindowSize();

  const IMG_STYLE= {
    height: size.width <= size.tailwind.md ? '92vh' : '100vh',
    marginTop: size.width <= size.tailwind.md ? '8vh' : '',
    objectFit:"cover",
    objectPosition:"77% 10%",
    width:"100%",
  }
  
  const CONTENT_STYLE= {
    top: "50%",
    transform: "translateY(-50%)",
    maxHeight:"max-content",
    maxWidth:"400px"
  }

  const OVERLAY_STYLE= {
    transform: "translateY(-50%)",
    background: size.width <= size.tailwind.md ? 'radial-gradient(rgba(0,0,0,0.30) 0%, rgba(0,0,0,0.60) 100%)' : '',
    height: size.width <= size.tailwind.md ? '96vh' : '100vh',
    marginTop: size.width <= size.tailwind.md ? '52vh' : '',
    top: '0px',
    right: '0px',
    bottom: '0px',
    left: '0px',
  }

  

  return (
    <div className="relative">
      <div className="absolute z-20" style={OVERLAY_STYLE}/>
      <div className="bg-gradient-to-tl from-bgDark via-lpGray to-bgDark w-screen h-screen flex flex-row-reverse">
        <div className="flex gap-8 my-auto mr-20 lg:mr-60">
          <div className="flex flex-col gap-36">
            <KPSlideCard dentistCard= {dentistCards[0]}/>
            <KPSlideCard dentistCard= {dentistCards[2]}/>
          </div>
          <div className="flex flex-col gap-36 mt-6">
            <KPSlideCard dentistCard= {dentistCards[1]} right/>
            <KPSlideCard dentistCard= {dentistCards[3]} right/>
          </div>
        </div>
        <div className={`flex flex-col justify-between align-left m-2 absolute inset-0 z-20 mx-10 lg:left-14`} style={CONTENT_STYLE}>
          <div className="z-10 px-4 max-w-2xl mx-auto sm:px-8 pb-12 md:pb-20 lg:pt-0">
            <h1 className="text-center lg:text-left text-white text-2xl sm:text-3xl lg:text-4xl font-semibold">Grow bigger with the XiViX Knowledge Portal</h1>
            <p className="mt-3 text-lg text-gray-500 sm:text-xl md:mt-5 md:max-w-3xl">
              <div className='my-2 mx-auto lg:mx-0 lg:my-4 w-32 border border-gray-300'/>
              <p className="text-center lg:text-left text-white my-1">A network of competence and knowledge, XiViX's Knowledge Portal enables learning and collaboration with key opinion leader from across the globe.</p>
            </p>
          </div>
        </div>
      </div>
    </div>
  )
}

export default KnowledgePortal2 */
